import type { IssueSibling } from '~/api/help-center/types/Issue.types'

export const getCustomerIssueClickedTrackingPayload = (
  { tag, customerIssue }: IssueSibling,
  step: number,
) => {
  return {
    name: 'customer_issue_clicked',
    screen_type: `diagno_step${step}`,
    zone: 'diagnosis',
    customer_issue: tag ? `${tag}-${customerIssue}` : customerIssue,
  }
}
